export default __webpack_public_path__ + "static/media/Statistics_2014.1b50cc15.zip";